import { twMerge } from 'tailwind-merge';
import { Alert, AlertProps } from '../Alert/Alert';

export const Toast: React.FC<Omit<AlertProps, 'children'> & { message: React.ReactNode }> = ({
  message,
  className,
  ...props
}) => (
  <Alert {...props} className={twMerge('z-50 w-full min-[600px]:w-[390px]', className)}>
    {message}
  </Alert>
);
